import RequisitesTable from "./RequisitesTable";

export default RequisitesTable;